import Box from '@mui/material/Box';

const SidebarSectionWrapper = ({ children }) => (
  <Box
    my={3}
    px={2}
  >
    {children}
  </Box>
);

export default SidebarSectionWrapper;